import React, { useEffect, useState } from 'react';
import { ContainerFull } from '../../components/ContainerFull';
import { Heading } from '../../components/Heading';
import { useDispatch, useSelector } from 'react-redux';
import { Wrapper } from '../../components/Wrapper';
import { CardRequestStudentUpdate } from './CardRequestStudentUpdate';
import { getAllRequest } from '../../redux/actions/request';
import { SkeletonRequestCard } from './skeleton/SkeletonRequestCard';
import { onlyRequests, optionsStatusRequest } from '../../static/data';
import { getTotalRequestStudentsPending } from '../../redux/actions/analytics';
import { DropDownFilterSingle } from '../../components/dropDown/DropDownFilterSingle';

export const RequestStudentsPage = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.user);
    const { roles, typeUser } = user;
    const { requestsStudents, loading } = useSelector((state) => state.request);
    const [filterRequest, setFilterRequest] = useState([]);
    const [searchRequest, setSearchRequest] = useState('');
    const [filterOption, setFilterOption] = useState("");

    useEffect(() => {
        onlyRequests.includes(typeUser) &&
            dispatch(getTotalRequestStudentsPending('pending'));
    }, [dispatch, typeUser]);

    useEffect(() => {
        if (searchRequest.trim() !== '') {
            const lowerSearch = searchRequest.toLowerCase();

            const filteredRequests = requestsStudents?.filter((request) => {
                const numberRequestMatch = request.numberRequest.toLowerCase().includes(lowerSearch);
                const matriculaMatch = request.student?.matricula?.toString().includes(lowerSearch);
                return numberRequestMatch || matriculaMatch;
            });

            setFilterRequest(filteredRequests);
        } else {
            setFilterRequest(requestsStudents);
        }
    }, [requestsStudents, searchRequest]);


    useEffect(() => {
        dispatch(getAllRequest());
    }, [dispatch]);

    if (roles !== 'admin') {
        window.location.href = '/'
    }

    useEffect(() => {
        let urlFilter = '/request/getAllRequestsStudents/?requestFrom=courses';

        if (filterOption === 'pending') {
            urlFilter += '&requestStatus=pending';
        }

        if (filterOption === 'done') {
            urlFilter += '&requestStatus=done';
        }
        dispatch(getAllRequest(urlFilter));

    }, [dispatch, filterOption]);

    const handleSearchText = (e) => {
        setSearchRequest(e.target.value);
    }

    return (
        <ContainerFull>
            <Heading
                title={'Control de estudiantes'}
                subtitle={typeUser === 'director' ? `Confirmar los cambios de estudiantes de cursos` : 'Solicitudes de cambios de estudiantes de curso'}
                center={false}
            />
            <div className="flex justify-end items-center mb-4 gap-2">
                <div>
                    <DropDownFilterSingle
                        title={"Estatus de Solicitud"}
                        options={optionsStatusRequest}
                        state={filterOption}
                        setState={setFilterOption}
                    />
                </div>
            </div>
            {
                (!loading && requestsStudents.length > 0) && (
                    <Wrapper>
                        <input
                            type="text"
                            placeholder="Buscar a estudiante por matricula o número de solicitud"
                            value={searchRequest}
                            onChange={(e) => handleSearchText(e)}
                            className='block w-full rounded-md border-0 py-2 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6' />
                    </Wrapper>
                )
            }
            <Wrapper>
                {
                    loading && (
                        <div className='w-full grid grid-cols-1 md:grid-cols-3 gap-4'>
                            <SkeletonRequestCard />
                            <SkeletonRequestCard />
                            <SkeletonRequestCard />
                            <SkeletonRequestCard />
                            <SkeletonRequestCard />
                            <SkeletonRequestCard />
                        </div>
                    )
                }
                <div className='w-full grid grid-cols-1 md:grid-cols-4 gap-4'>
                    {
                        !loading && filterRequest.length === 0 && (
                            <div className='w-full flex justify-start items-start p-4 rounded-md'>
                                <p className='text-gray-900 text-[1rem] tracking-wide'>No hay solicitudes pendientes</p>
                            </div>
                        )
                    }
                    {
                        !loading && filterRequest.length > 0 && filterRequest.map(({
                            _id: id,
                            numberRequest,
                            student,
                            approvedBy,
                            requestBy,
                            createdAt,
                            requestType,
                            requestStatus,
                            courses
                        }) =>
                        (
                            <CardRequestStudentUpdate
                                key={id}
                                id={id}
                                numberRequest={numberRequest}
                                student={student}
                                approvedBy={approvedBy}
                                requestBy={requestBy}
                                requestDate={createdAt}
                                requestType={requestType}
                                requestStatus={requestStatus}
                                courses={courses}
                                setFilterOption={setFilterOption}
                            />
                        ))
                    }
                </div>
            </Wrapper>
        </ContainerFull>
    )
}
